export class FormCollectModel {
    id: string;

    title: string;

    description: string;

    fields: any[];

    value: any = {};
}
